import { CaretRightOutlined, PauseOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../Components/Button"
import Icon from "../../../../Icon"

/**
 * Trial's MapControls: one glass surface pinned to the globe's top-right corner, stacked
 * vertically. Order follows Trial: play/pause, reset, zoom out, zoom in. The pause and play
 * glyphs come from @ant-design/icons, which the app already uses, because the SVG registry has
 * no pause icon and adding one is not ours to do.
 */
const GlobeControls = ({
  onZoomIn,
  onZoomOut,
  onReset,
  onToggleAutoSpin,
  canZoomIn,
  canZoomOut,
  canReset,
  isAutoSpinning
}) => {
  const { t } = useTranslation()
  return (
    <div className="globe-controls">
      <ButtonComponent
        type="text"
        className="globe-controls_btn"
        aria-label={isAutoSpinning ? t("Pause rotation") : t("Resume rotation")}
        icon={isAutoSpinning ? <PauseOutlined /> : <CaretRightOutlined />}
        onClick={onToggleAutoSpin}
      />
      <span className="globe-controls_divider" aria-hidden="true" />
      <ButtonComponent
        type="text"
        className="globe-controls_btn"
        aria-label={t("Reset view")}
        icon={<Icon type="arrow_rotate" />}
        disabled={!canReset}
        onClick={onReset}
      />
      <span className="globe-controls_divider" aria-hidden="true" />
      <ButtonComponent
        type="text"
        className="globe-controls_btn"
        aria-label={t("Zoom out")}
        icon={<Icon type="minus" />}
        disabled={!canZoomOut}
        onClick={onZoomOut}
      />
      <span className="globe-controls_divider" aria-hidden="true" />
      <ButtonComponent
        type="text"
        className="globe-controls_btn"
        aria-label={t("Zoom in")}
        icon={<Icon type="plus" />}
        disabled={!canZoomIn}
        onClick={onZoomIn}
      />
    </div>
  )
}

export default GlobeControls
